<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      const { cssVars } = window;
      cssVars();
    },
  },
};
</script>

<style>
#app {
  width:100%;
  height:100%;
  font-family: 'VODAFONE';
}
.leaflet-bar a{
  background-color: var(--primary) !important;
  color: #fff !important;
}
</style>
